module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_35.27047545.jpg";